import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledCollaboratorInformations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledCalibrationTransition = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const StyledCollaboratorDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const StyledCollaboratorToView = styled.div`
  border: 1px solid ${theme.colors.purple_2};
  border-radius: ${theme.variables.border_radius_1};
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  justify-content: space-between;
`;

export const StyledCmCollaborator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  border: 1px solid ${theme.colors.black};
  border-radius: 5px;
  padding: 2px 8px;
`;
